import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowLeft, Rainbow, Smile } from 'lucide-react';
import { usePinGate } from '../hooks/usePinGate';

const HelloPage: React.FC = () => {
  const navigate = useNavigate();
  const { pinUrl, helloUrl, setErrorMessage, refreshStatus } = usePinGate();

  return (
    <div className="min-h-dvh bg-gradient-to-br from-pink-100 via-white to-sky-100 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full bg-white/90 backdrop-blur-lg rounded-3xl shadow-2xl border border-pink-100 p-10 text-center space-y-8">
        <div className="relative flex justify-center">
          <div className="absolute -inset-5 rounded-full bg-gradient-to-br from-pink-300 via-purple-200 to-sky-200 blur-xl opacity-70" />
          <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-pink-500 to-purple-500 text-white flex items-center justify-center shadow-lg">
            <Sparkles className="h-10 w-10" />
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-extrabold text-gray-900 flex items-center justify-center gap-2">
            <Rainbow className="h-7 w-7 text-pink-400" />
            Hello, Sunshine!
          </h1>
          <p className="text-gray-600 leading-relaxed">
            You&apos;ve stumbled into our whimsy lounge where we celebrate
            unexpected detours. Grab an imaginary lemonade, stretch those
            fingers, and enjoy a quick story before you head back.
          </p>
        </div>

        <div className="bg-pink-50 rounded-2xl p-5 text-pink-700 flex items-start gap-3 text-left">
          <Smile className="h-6 w-6" />
          <span className="text-sm font-medium">
            Once upon a snack break, someone tried to open the KeepSafe jar with
            a rubber chicken. The jar refused, the chicken squawked, and
            everyone agreed a friendly keypad might be smarter. The end.
          </span>
        </div>

        <button
          type="button"
          onClick={() => {
            setErrorMessage(null);
            void refreshStatus();
            navigate(pinUrl || '/pin', { replace: true });
          }}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold shadow-lg hover:from-pink-600 hover:to-purple-600 focus:ring-2 focus:ring-pink-300 focus:ring-offset-2 transition-all"
        >
          <ArrowLeft className="h-5 w-5" />
          Back to PIN Pad
        </button>

        <p className="text-xs text-gray-400">
          If you believe you&apos;re seeing this by mistake, let your friendly
          admin know. This page lives at{' '}
          <code className="font-mono px-2 py-1 bg-gray-100 rounded-md">
            {helloUrl || '/hello'}
          </code>
        </p>
      </div>
    </div>
  );
};

export default HelloPage;
